import { CreatorAvatar } from './RankList'
import { barWidth } from './bars'
import styles from './Widgets.module.css'

// Height of one row, in pixels, at the default card size, so a list can be
// fitted to its widget: it holds a 24px avatar. A bigger card scales it up
// to the max (useFittedRows), and the rows then share the box exactly; it
// never depends on what a row contains.
export const BAR_ROW_HEIGHT = 36
export const BAR_ROW_MAX_HEIGHT = 48

// Ranked horizontal bars with the value written beside each one, so identity
// never relies on color and the top item reads at a glance. An item can
// lead with its avatar (item.avatar: { src, name }). format gets the
// item too, so a money value can be written in the item's own currency.
export function BarList({ items, format = (value) => String(value), series = '1', label, onSelect, rowHeight = BAR_ROW_HEIGHT }) {
  const max = Math.max(...items.map((item) => item.value), 0) || 1
  return (
    <ol className={styles.bars} aria-label={label} style={{ '--bar-row-height': `${rowHeight}px` }}>
      {items.map((item) => {
        const body = (
          <>
            {item.avatar ? (
              <span className={styles.barName}>
                <CreatorAvatar name={item.avatar.name} src={item.avatar.src} />
                <span className={styles.barLabel} title={item.label}>{item.label}</span>
              </span>
            ) : <span className={styles.barLabel} title={item.label}>{item.label}</span>}
            <span className={styles.barTrack} aria-hidden="true">
              <span className={styles.barFill} data-series={series} style={{ width: barWidth(item.value, max) }} />
            </span>
            <span className={styles.barValue}>{format(item.value, item)}</span>
          </>
        )
        return (
          <li key={item.key || item.label} className={styles.barRow}>
            {onSelect ? (
              <button type="button" className={styles.barButton} onClick={() => onSelect(item)}>{body}</button>
            ) : <span className={styles.barButton}>{body}</span>}
          </li>
        )
      })}
    </ol>
  )
}
